if (document.querySelector('.page-template-template-blog') || document.querySelector('.category')) {
    let blogTabs = document.querySelectorAll(".blog-sorting__tabs li a");
    let blogURL = document.querySelector("input[name='base']").value;
    let blogSorting = document.querySelector(".blog-sorting__dropdown");
    let blogRoot = document.querySelector(".blog-articles");

    for (let i = 0; i < blogTabs.length; i++) {
        blogTabs[i].addEventListener('click', function (e) {
            e.preventDefault();

            for (let a = 0; a < blogTabs.length; a++) {
                blogTabs[a].closest('li').classList.remove("active");
            };

            currentBlogTab = this.getAttribute('data-slug');
            this.closest('li').classList.add('active');

            changeCatsLoadPosts(currentBlogTab);
        });
    }

    blogSorting.addEventListener('change', function (e) {
        let selectedOrdering = this.options[this.selectedIndex].getAttribute('data-order');
        let selectedOrderBy = this.options[this.selectedIndex].getAttribute('data-orderby');

        let XHRData = new FormData();
        let XHRResponse = '';

        XHRData.append("clicked", currentBlogTab);
        XHRData.append("current_page", WPAJAX.current_page);
        XHRData.append("paged", WPAJAX.current_page);
        XHRData.append("base", blogURL);
        XHRData.append("orderby", selectedOrderBy);
        XHRData.append("order", selectedOrdering);
        XHRData.append("action", "loadPosts");

        let navigationXHR = new Promise((resolve, reject) => {
            let linkXHR = new XMLHttpRequest();

            linkXHR.open('POST', WPAJAX.ajaxurl, true);

            linkXHR.onload = function () {
                if (linkXHR.readyState == 4 && linkXHR.status == 200) {
                    resolve("result");
                    XHRResponse = linkXHR.responseText;
                }
            };

            linkXHR.onerror = function () {
                reject("error");
            };

            linkXHR.send(XHRData);
        });

        navigationXHR.then(
            result => {
                blogRoot.innerHTML = '',
                    blogRoot.innerHTML += XHRResponse;
                let paginationLinks = document.querySelectorAll('.blog-articles__pagination a');

                WPAJAX.selected_ordering = selectedOrdering;
                WPAJAX.selected_orderby = selectedOrderBy;

                for (let g = 0; g < paginationLinks.length; g++) {
                    paginationLinks[g].addEventListener('click', function (e) {
                        e.preventDefault();
                        paginationLink = this.getAttribute('href');
                        let page_number = getPageNumberFromURL(paginationLink);
                        goToPage(paginationLink, page_number[1]);
                    });
                }
            },
            error => blogRoot.innerHTML = 'An error has occured',
        );
    })

    function goToPage(paged) {
        let XHRData = new FormData();
        let XHRResponse = '';

        let pageNumber = getPageNumberFromURL(paged);

        XHRData.append("clicked", currentBlogTab);
        XHRData.append("current_page", WPAJAX.current_page);
        XHRData.append("paged", pageNumber);
        XHRData.append("base", blogURL);
        XHRData.append("orderby", WPAJAX.selected_orderby);
        XHRData.append("order", WPAJAX.selected_ordering);
        XHRData.append("action", "loadPosts");

        let navigationXHR = new Promise((resolve, reject) => {
            let linkXHR = new XMLHttpRequest();

            linkXHR.open('POST', WPAJAX.ajaxurl, true);

            linkXHR.onload = function () {
                if (linkXHR.readyState == 4 && linkXHR.status == 200) {
                    resolve("result");
                    XHRResponse = linkXHR.responseText;
                }
            };

            linkXHR.onerror = function () {
                reject("error");
            };

            linkXHR.send(XHRData);
        });

        navigationXHR.then(
            result => {
                blogRoot.innerHTML = '',
                    blogRoot.innerHTML += XHRResponse;
                let paginationLinks = document.querySelectorAll('.blog-articles__pagination a');
                WPAJAX.current_page = pageNumber;

                for (let g = 0; g < paginationLinks.length; g++) {
                    paginationLinks[g].addEventListener('click', function (e) {
                        e.preventDefault();
                        paginationLink = this.getAttribute('href');
                        let page_number = getPageNumberFromURL(paginationLink);
                        goToPage(paginationLink, page_number[1]);
                    });
                }
            },
            error => blogRoot.innerHTML = 'An error has occured',
        );
    };

    function getPageNumberFromURL(link) {
        // let page_number = link.match(/(?!:paged=)([0-9])/);
        let explodedURL = link.split(/[-!$%^&*()_+|~=`{}\[\]:\/;<>?,.@#]+/);
        let pagedLocation = explodedURL.indexOf('paged');

        if (pagedLocation != -1) {
            let pagedValue = explodedURL[pagedLocation + 1];
            console.log(pagedValue);
            return pagedValue;
        } else {
            console.error('paged not found');
            return 1;
        }
    }

    function changeCatsLoadPosts(currentBlogTab) {
        let AJAXLink = WPAJAX.ajaxurl;
        let XHRData = new FormData();
        let XHRResponse = '';

        XHRData.append("clicked", currentBlogTab);
        XHRData.append("current_page", WPAJAX.current_page);
        XHRData.append("paged", 1);
        XHRData.append("base", blogURL);
        XHRData.append("orderby", WPAJAX.selected_orderby);
        XHRData.append("order", WPAJAX.selected_ordering);
        XHRData.append("action", "loadPosts");

        let sentXHR = new Promise((resolve, reject) => {
            let categoryPostsXHR = new XMLHttpRequest();
            categoryPostsXHR.open('POST', AJAXLink, true);

            categoryPostsXHR.onload = function () {
                if (categoryPostsXHR.readyState == 4 && categoryPostsXHR.status == 200) {
                    resolve("result");
                    XHRResponse = categoryPostsXHR.responseText;
                }
            };

            categoryPostsXHR.onerror = function () {
                reject("error");
            };

            categoryPostsXHR.send(XHRData);
        });

        sentXHR.then(

            result => {
                blogRoot.innerHTML = '',
                    blogRoot.innerHTML += XHRResponse;
                let paginationLinks = document.querySelectorAll('.blog-articles__pagination a');
                WPAJAX.current_page = 1;

                for (let g = 0; g < paginationLinks.length; g++) {
                    paginationLinks[g].addEventListener('click', function (e) {
                        e.preventDefault();
                        paginationLink = this.getAttribute('href');
                        let page_number = getPageNumberFromURL(paginationLink);
                        goToPage(paginationLink, page_number);
                    });
                }
            },
            error => blogRoot.innerHTML = 'An error has occured',
        );
    }
}